import { LinkedSectionsModel } from '../../sections/models/linked_sections_model';
import { RegistrationWaitlistPositionModel } from '../models/registration_waitlist_position_model';
import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';
import { ITermCoursesDatasource } from '../../term_courses/datasources/term_courses_datasource';
import { IWaitlistStatusDatasource } from '../datasources/waitlist_status_datasource';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { ICampusesDatasource } from '../../sections/datasources/campuses_datasource';
import { ISectionTimesDatasource } from '../../sections/datasources/section_times_datasource';
import { ILocationsDatasource } from '../../sections/datasources/locations_datasource';
import { SchedulerModel } from '../models/scheduler_model';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISectionAvailabilityDatasource } from '../../sections/datasources/section_availability_datasource';
import { ISectionLabelsDatasource } from '../../sections/datasources/section_labels_datasource';
import { LoadCrossCourseLinkedSectionsFacade } from '../../sections/facades/load_cross_course_linked_sections_facade';

angular
  .module('capability-ng-scheduler')
  .factory(
    'getCourseSchedulerCommand',
    (
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngCampusesDatasource: ICampusesDatasource,
      ngLocationsDatasource: ILocationsDatasource,
      ngSectionTimesDatasource: ISectionTimesDatasource,
      ngSectionsDatasource: ISectionsDatasource,
      ngSchedulerModel: SchedulerModel,
      ngWaitlistStatusDatasource: IWaitlistStatusDatasource,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      ngSectionLabelsDatasource: ISectionLabelsDatasource,
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      ngRegistrationWaitlistPositionModel: RegistrationWaitlistPositionModel,
      ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
      ngLinkedSectionsModel: LinkedSectionsModel,
      $q: ng.IQService,
      ngLoadCrossCourseLinkedSectionsFacade: LoadCrossCourseLinkedSectionsFacade,
      log: any
    ): ICommand => {
      return defineCommand(
        'getCourseSchedulerCommand',
        (deferred: ng.IDeferred<IQuery[]>, termId: number): ng.IPromise<void> => {
          return $http({
            method: 'GET',
            url: `reg/course_schedule/term/${termId}/`
          })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              ngCampusesDatasource.write(data.campus);
              ngLocationsDatasource.write(data.location);
              ngLinkedSectionsModel.clear().write(data.section_link);
              ngSectionTimesDatasource.write(data.section_time);
              ngSectionLabelsDatasource.write(data.section_labels);
              ngWaitlistStatusDatasource.write(data.section_status);
              ngSectionAvailabilityDatasource.clear().write(data.section_status);
              ngRegistrationWaitlistPositionModel.clear();
              ngSectionsDatasource.write(data.section);
              _4.each(data.waitlist_position, (position: any) => {
                ngRegistrationWaitlistPositionModel.put({
                  place_in_waitlist: position.place_in_waitlist,
                  waitlist_position: position.position,
                  section: position.section
                });
              });
              const missingSections = ngLoadCrossCourseLinkedSectionsFacade.loadCrossCourseLinkedSections(
                data.section_link
              );
              $q.all(missingSections).then(() => {
                deferred.resolve(QueryMediator.runQueries(ngSchedulerModel));
              });
            })
            .catch((e) => {
              log.issue('Failed to get scheduled sections for this term');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/get_course_scheduler_command.ts